import dev from '#assets/js/dev.js'
import * as contracts from './contracts.js'

dev(contracts)
